import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import Header from '@components/Header';
import Footer from '@components/Footer';

function Login() {
    const navigate = useNavigate();
    const { login, loading } = useAuth();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [rememberMe, setRememberMe] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const result = await login(formData.email, formData.password, rememberMe);

        if (result.success) {
            navigate('/');
        } else {
            setError(result.message || 'Login gagal');
        }
    };

    return (
        <div className="auth-page">
            <Header />

            <main className="auth-container" style={{ maxWidth: '400px', margin: '120px auto', padding: '2rem' }}>
                <h2>Masuk</h2>

                {error && (
                    <div style={{ background: 'rgba(255, 107, 107, 0.1)', border: '1px solid #ff6b6b', borderRadius: '8px', padding: '12px', marginBottom: '1rem', color: '#ff6b6b' }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#ccc' }}>Email atau Username</label>
                        <input
                            type="text"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            required
                            style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(0,0,0,0.3)', color: '#fff' }}
                        />
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#ccc' }}>Password</label>
                        <input
                            type="password"
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            required
                            style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(0,0,0,0.3)', color: '#fff' }}
                        />
                    </div>

                    {/* Remember Me Checkbox */}
                    <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                            type="checkbox"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                        />
                        <label htmlFor="rememberMe" style={{ color: '#ccc', cursor: 'pointer', userSelect: 'none' }}>
                            Ingat saya selama 30 hari
                        </label>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="auth-btn primary"
                        style={{ width: '100%', padding: '0.75rem', marginTop: '1rem' }}
                    >
                        {loading ? 'Memproses...' : 'Masuk'}
                    </button>
                </form>

                <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
                    <Link to="/forgot-password" style={{ color: '#d4af37', textDecoration: 'none' }}>
                        Lupa Password?
                    </Link>
                </div>

                <div style={{ marginTop: '1rem', textAlign: 'center', color: '#999' }}>
                    Belum punya akun?{' '}
                    <Link to="/register" style={{ color: '#d4af37', textDecoration: 'none' }}>
                        Daftar
                    </Link>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default Login;
